// extracted by mini-css-extract-plugin
export default {"main":"styles_main__b6hoV","header":"styles_header__ACO0G","headerBox":"styles_headerBox__7mxrm","redTxt":"styles_redTxt__wasGX"};